import { render } from "./custom.vue?vue&type=template&id=e80d3a7c"
import script from "./custom.vue?vue&type=script&lang=js"
export * from "./custom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__